<template>
  <v-layout>
    <v-flex :xs6="sending" :xs12="!sending">
    <ServerIterator 
      v-if="reset"
      :items="items" 
      title="Messages" 
      :displayItem="displayComponent" 
      :displayArgs="curMsg"
      :changedArgs.sync="changedArgs"
      :total='total'
      :currentPage.sync="currentPage"
      >
      <template v-slot:topbar>
        <v-toolbar id="topbar"   dense>
          <v-toolbar-title>Messages</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}" :close-on-click="closeOnClick">
              <v-icon class="msg-icon" v-bind="attrs" v-on="on">mdi-priority-high</v-icon>
            </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in ['All','High', 'Medium', 'Low']"
                  :key="index"
                >
                  <v-list-item-title @click="setPriority(item)">{{item}}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}" :close-on-click="closeOnClick">
              <v-icon class="msg-icon" v-bind="attrs" v-on="on">mdi-format-list-checks</v-icon>
            </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in ['All','Unread', 'Read']"
                  :key="index"
                >
                  <v-list-item-title @click="setRead(item)">{{item}}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-icon class="msg-icon" @click="newmsg()">mdi-message-draw</v-icon>
        </v-toolbar>
      </template>
    </ServerIterator>
    </v-flex>
    <v-flex :xs6="sending" v-if="sending">
      <SendMessage :closeSendWidget.sync="closeSend" :msg="curMsg"
      :changedArgs.sync="changedArgs"/>
    </v-flex>
  </v-layout>
</template>

<script>
import itemDisplay from './DisplayOne.vue'
import ServerIterator from '@/../../coreui/components/ServerIterator.vue'
import SendMessage from './SendMessage'
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  components: {
    ServerIterator,
    itemDisplay,
    SendMessage
  },
  data () {
    return {
      reset: true,
      currentPage: {page: 1, items: 0},
      total: 0,
      items:[],
      pipeline: [],
      matchAnd: [],
      displayComponent: itemDisplay,
      closeOnClick: true,
      sending: false,
      closeSend: false,
      matchAnd: [],
      priority: {},
      show: 'All',
      read: 'All',
      curMsg: {op: 'new', 'item': {}},
      changedArgs: null
    }
  },
  computed: {
    origLoggedinUser: sync("login/origLoggedinUser")
  },
  watch: {
    currentPage: {
      deep: true,
      async handler (val) {
        await this.getMessages((val.page - 1) * val.items, val.items)
      }
    },
    closeSend (val) {
      this.sending = false
      if (val.op == 'send') this.redraw()
    },
    async changedArgs(val) {
      this.sending = false
      if (val.op == 'remove') {
        let res = await axiosInstances.origApiServer.get(
          '/dt/v1/inf_global/'+val.item._id
        )
        if (res != null || res.data != null) {
          let item = res.data['rec']
          var self = this
          item = item.filter(function( obj ) {
              return obj.user !== self.origLoggedinUser._id
          })
          await axiosInstances.origApiServer.patch('/dt/v1/inf_global/'+val.item._id, {'rec': item})
          this.redraw()
        }
      } else {
        this.curMsg = val
        this.$nextTick(() => {this.sending = true})
      }
    }
  },
  methods: {
    setPriority(val) {
      if (val != 'All') {
        this.priority['priority'] = val.toLowerCase()
      } else {
        this.priority = {}
      }
      this.redraw()
    },
    newmsg() {
      this.curMsg = {op: 'new', 'item': {}}
      this.sending = !this.sending
    },
    setRead(val) {
      this.show = val
      this.redraw()
    },
    redraw () {
      this.closeSend = {'op': 'close'}
      this.reset = false
      this.$nextTick(() => {this.reset = true})
    },
    async getMessages (skip, limit) {
      let recuser 
      if (this.show == 'All') {
        recuser = { '$elemMatch': {user: this.origLoggedinUser._id}}
      } else if (this.show == 'Unread') {
        recuser = {'$elemMatch': {user: this.origLoggedinUser._id, status: 'new'}}
      } else {
        recuser = {'$elemMatch': {user: this.origLoggedinUser._id, status: 'read'}}
      }
      this.pipeline =[
        {
          '$match': {
            '$and': [
              this.priority,
              {rec: recuser}
            ]
          }
        }
      ]
      this.pipeline.push({
        "\$sort": {
          "cts" : -1
        }
      })
      this.pipeline.push({
          $facet: {
            pages: [
              { $skip: skip },
              { $limit: limit }
            ],
            total: [{ $count: "count" }],
          },
        })
      let url = '/misc/dbops?c=inf_global&op=pipe'
      let res = await axiosInstances.origApiServer.post(url, this.pipeline)
      if (res != null && res.data != null && res.data[0].total.length > 0) {
        this.items = res.data[0].pages
        this.total = res.data[0].total[0].count
      } else {
        this.items = []
        this.total = 0
      }
    }
  },
  mounted () {
    this.total = 0
    this.setPriority('All')
    this.getMessages(0, 10)
  }
}
</script>
<style scoped>
.topbar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6em;
  z-index: 2;
}
.msg-icon {
  margin-right: 20px;
}
</style>